import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DateEditComponent } from './dateedit.component';

const routes: Routes = [
  { path: '', component: DateEditComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DateEditRoutingModule { }
